export const themeOptionFactory = (theme) => ({
  assets: {
    empty: {
      service: {
        icon_path:
          "M23.9687 4.25935C23.9358 4.15183 23.8715 4.05661 23.7841 3.98592C23.6966 3.91524 23.5901 3.87231 23.478 3.86265L20.127 3.372L18.6342 0.33416C18.5875 0.23275 18.5123 0.147141 18.4178 0.0878104C18.3232 0.0284796 18.2134 -0.00199995 18.1018 0.000101811C17.991 0.00172421 17.8827 0.033732 17.7888 0.0926369C17.695 0.151542 17.619 0.235084 17.5694 0.33416L16.0766 3.372L12.7255 3.86265C12.6072 3.87006 12.4939 3.91328 12.4007 3.98657C12.3075 4.05986 12.2388 4.15976 12.2037 4.27301C12.1686 4.38626 12.1687 4.5075 12.2042 4.62066C12.2396 4.73382 12.3085 4.83354 12.4019 4.90658L14.0096 6.48292L14.9178 5.63734L14.0826 4.85439L16.5568 4.49945C16.6512 4.48697 16.741 4.45074 16.8177 4.39414C16.8944 4.33755 16.9554 4.26244 16.9952 4.17583L18.1018 1.94182L19.2084 4.17583C19.2527 4.26105 19.3165 4.3347 19.3944 4.39089C19.4724 4.44709 19.5624 4.48426 19.6572 4.49945L22.1314 4.85439L20.3462 6.60819C20.28 6.6764 20.2304 6.75902 20.2015 6.84958C20.1725 6.94013 20.1649 7.03617 20.1792 7.13016L20.6072 9.59384L18.3941 8.42464C18.3076 8.38374 18.2131 8.36253 18.1174 8.36253C18.0218 8.36253 17.9273 8.38374 17.8408 8.42464L15.6277 9.59384L16.0452 7.13016C16.0641 7.03613 16.0586 6.93885 16.0294 6.84751C16.0002 6.75618 15.9481 6.67381 15.8782 6.60819L14.9178 5.63734L14.0096 6.42029L14.8238 7.21367L14.2497 10.5438C14.227 10.653 14.2367 10.7665 14.2775 10.8703C14.3183 10.9741 14.3884 11.0638 14.4793 11.1284C14.5742 11.1844 14.6824 11.214 14.7925 11.214C14.9027 11.214 15.0108 11.1844 15.1057 11.1284L18.1018 9.55208L21.0979 11.1284C21.1863 11.169 21.2824 11.1903 21.3797 11.1911C21.5059 11.1935 21.6298 11.157 21.7347 11.0867C21.8229 11.0193 21.8917 10.9296 21.9339 10.8269C21.976 10.7241 21.9902 10.612 21.9748 10.5021L21.3902 7.24499L23.8225 4.86483C23.9015 4.78794 23.9571 4.6903 23.983 4.58317C24.0088 4.47604 24.0039 4.36378 23.9687 4.25935ZM18.9578 15.6591H14.9282C15.1116 15.2693 15.1699 14.8323 15.0952 14.408C15.0204 13.9838 14.8162 13.593 14.5107 13.2894L10.7525 9.5312L9.85472 10.3037L13.6755 14.1245C13.8439 14.2979 13.938 14.5301 13.938 14.7717C13.938 15.0134 13.8439 15.2456 13.6755 15.419C13.5344 15.5629 13.3444 15.6486 13.1431 15.6591C12.9874 15.6689 12.8313 15.6471 12.6842 15.5951C12.5371 15.543 12.402 15.4618 12.2871 15.3563L10.0426 13.352C9.92954 13.2417 9.77782 13.1799 9.61984 13.1799C9.46185 13.1799 9.31013 13.2417 9.19704 13.352C9.09591 13.4729 9.04496 13.6279 9.05467 13.7852C9.06438 13.9425 9.13401 14.0901 9.24924 14.1976L11.4937 16.1915C11.9195 16.5866 12.4787 16.8066 13.0596 16.8074H18.9474C19.1578 16.8074 19.3596 16.891 19.5084 17.0398C19.6572 17.1886 19.7408 17.3904 19.7408 17.6008C19.7408 17.8112 19.6572 18.013 19.5084 18.1618C19.3596 18.3106 19.1578 18.3942 18.9474 18.3942H11.9948C11.5094 18.3927 11.0373 18.2353 10.6481 17.9453L5.42845 14.2498C5.07752 13.9957 4.66823 13.8341 4.23837 13.78V8.45595H6.77512C7.18977 8.45356 7.60076 8.53353 7.98426 8.69123C8.36776 8.84893 8.71612 9.08122 9.00914 9.37461L9.89648 10.262L10.7943 9.48945L9.84428 8.53947C9.02437 7.73916 7.92081 7.29624 6.77512 7.30763H0.626359C0.462695 7.31525 0.30777 7.38369 0.191917 7.49954C0.0760632 7.6154 0.00762448 7.77032 0 7.93399V14.3646C0.00762448 14.5283 0.0760632 14.6832 0.191917 14.7991C0.30777 14.9149 0.462695 14.9833 0.626359 14.991H3.94606C4.23104 14.9945 4.50804 15.0856 4.73945 15.252L9.95911 18.9475C10.5632 19.3939 11.2959 19.6321 12.047 19.626H18.9891C19.5152 19.626 20.0197 19.4171 20.3917 19.0451C20.7636 18.6731 20.9726 18.1686 20.9726 17.6426C20.9726 17.1165 20.7636 16.612 20.3917 16.24C20.0197 15.8681 19.5152 15.6591 18.9891 15.6591H18.9578ZM3.05872 13.8009H1.19008V8.49771H3.05872V13.8009ZM8.75859 12.5482C8.75859 12.6411 8.73104 12.7319 8.67942 12.8092C8.6278 12.8864 8.55443 12.9466 8.46859 12.9822C8.38276 13.0177 8.2883 13.027 8.19717 13.0089C8.10605 12.9908 8.02234 12.946 7.95664 12.8803C7.89095 12.8146 7.8462 12.7309 7.82808 12.6398C7.80995 12.5487 7.81926 12.4542 7.85481 12.3684C7.89037 12.2826 7.95058 12.2092 8.02783 12.1576C8.10508 12.1059 8.19591 12.0784 8.28882 12.0784C8.41341 12.0784 8.5329 12.1279 8.621 12.216C8.7091 12.3041 8.75859 12.4236 8.75859 12.5482Z",
      },
    },
  },
  components: {
    EmServicePage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(175px, 1fr))",
          justifyItems: "center",
          gap: theme.spacing(1),
          "@media (max-width: 400px)": {
            gridTemplateColumns: "repeat(auto-fill, minmax(145px, 1fr))",
          },
        },
        serviceImageCard: {
          maxWidth: "180px",
          boxShadow: "0px 8px 24px 0px rgba(155, 155, 155, 0.15)",
          display: "block",
          overflow: "hidden",
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
          "& .MuiCardActionArea-root": {
            width: "100%",
            height: "100%",
            "&:after": {
              display: "none",
            },
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-root": {
            height: "35%",
            padding: theme.spacing(1, 0.75, 0),
            paddingBottom: 0,
            background: theme.palette.background.paper,
            alignItems: "flex-start",
            position: "relative",
            "& .MuiAvatar-root": {
              width: "40px",
              height: "40px",
              borderRadius: "4px",
            },
            "& .MuiCardHeader-subheader": {
              borderTop: `1px solid ${theme.palette.primary.main}`,
              paddingTop: theme.spacing(0.5),
              color: theme.palette.text.primary,
              display: "flex",
              alignItems: "center",
              whiteSpace: "nowrap",
              width: "100%",
              gap: theme.spacing(0.5),
              justifyContent: "space-between",
              minWidth: 0,
            },
            "& .MuiCardHeader-subheader .sub-category-text": {
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "min(0.75rem, 2.5vw)",
            },
            "& .MuiCardHeader-subheader .location-text": {
              background: theme.palette.common.black,
              color: theme.palette.common.white,
              marginLeft: "auto",
              width: "fit-content",
              padding: theme.spacing(0.5, 1.25),
              borderTopLeftRadius: "20px",
              overflow: "hidden",
              display: "block",
            },
            "& .MuiCardHeader-content": {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              marginBottom: theme.spacing(-0.5),
              marginRight: theme.spacing(-0.5),
              overflow: "hidden",
            },
            "& .MuiCardHeader-title": {
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              marginBottom: theme.spacing(0.1875),
              color: theme.palette.text.primary,
              paddingRight: theme.spacing(0.5),
              paddingBottom: 0,
              fontSize: "min(0.875rem, 3vw)",
            },
          },
          "& .MuiCardMedia-img": {
            width: "100%",
            height: "65%",
            backgroundColor: "rgb(189, 189, 189)",
          },
        },
        emptyDataContainer: {
          height: `calc(100vh - ${
            theme?.mixins?.mobileHeader?.height || 80
          }px - ${theme?.mixins?.bottomNavigation?.height + 30}px - 72px)`,
          // Prevent content page overlap with footer shadow by adding a bottom space (30px)
          //72 px is container padding
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        venueSelector: {
          position: "fixed",
          bottom: theme?.mixins?.bottomNavigation?.height + 45,
          left: "24px",
          zIndex: 1, // Prevents restaurants' info from appearing on top
        },
        filterSection: {},
        filterContainer: {},
      },
    },
  },
})
